<h3>
    <a ng-click="viewDetails($event, item)" ng-bind-html="item.name|cHighlight:highlight"></a>
</h3>

<div ng-if="item.description" style="padding: 5px 0 0 0">
    {{ item.description }}
</div>

<ul class="workflow-property-list" style="padding: 5px 0 0 0">
    <li>{{ "report.public"|translate }}  {{ visibleString() }}</li>
    <li>{{ "report.allowed.groups"|translate }}: {{ item.viewableBy.join(', ') }}</li>
</ul>